import { BookOpen, ArrowUpRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useLang, scrollTo } from "@/App";
import { Reveal, ChapterHead } from "@/components/Section";

const Publications = () => {
  const { t } = useLang();
  const navigate = useNavigate();

  const onClick = (p) => {
    if (p.link) navigate(p.link);
    else if (p.target) scrollTo(p.target);
  };

  return (
    <section id="publications" data-testid="publications-section" className="relative px-5 md:px-10 py-28 md:py-40 bg-parchment scroll-mt-20">
      <div className="max-w-[1600px] mx-auto">
        <ChapterHead kicker={t.publications.kicker} title={t.publications.title} testId="publications" />

        <div className="border-t border-line">
          {t.publications.items.map((p, i) => (
            <Reveal key={i} delay={i * 0.06} y={24}>
              <button
                data-testid={`publication-item-${i}`}
                onClick={() => onClick(p)}
                className="group w-full grid md:grid-cols-[64px_1fr_auto] items-start md:items-center gap-4 md:gap-10 py-8 md:py-12 border-b border-line text-left px-2 md:px-4 -mx-2 md:-mx-4 hover:bg-paper transition-colors cursor-pointer"
              >
                <span className="font-display italic text-2xl md:text-3xl text-terra">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div>
                  <div className="flex items-center gap-3 flex-wrap">
                    <h3 className="font-display text-2xl md:text-4xl leading-tight text-ink group-hover:text-terra transition-colors">
                      {p.title}
                    </h3>
                    <BookOpen size={18} className="text-terra shrink-0" />
                  </div>
                  <p className="text-sm text-muted2 mt-2 leading-relaxed max-w-2xl">{p.desc}</p>
                </div>
                <div className="flex items-center gap-4 md:justify-end">
                  <div className="md:text-right">
                    <p className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-bronze">{p.type}</p>
                    <p className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-muted2 mt-1">{p.year}</p>
                  </div>
                  <ArrowUpRight size={18} className="text-muted2 group-hover:text-terra group-hover:translate-x-1 group-hover:-translate-y-1 transition-all" />
                </div>
              </button>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p data-testid="publications-note" className="font-mono2 text-[10px] uppercase tracking-[0.2em] text-muted2 mt-10">
            {t.publications.note}
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default Publications;
